'use client'

import { useReducedMotion } from 'motion/react'
import React from 'react'

import { GlowBorderCard } from '@/components/ui/glow-border-card'
import { cn } from '@/utilities/ui'

/** Matches PromotionCard `rounded-[1.375rem]` (22px). */
export const FEATURED_PROMOTION_BORDER_RADIUS = '1.375rem'

/** Pink-forward palette with brand turquoise, blue, and magenta accents. */
const FEATURED_PINK_GLOW_COLORS = [
  '#fcdcff',
  '#f9b5fe',
  '#e96df2',
  '#d946ef',
  '#69e1bb',
  '#b0d9ff',
  '#f9b5fe',
  '#ff9cf7',
  '#c026d3',
  '#fcdcff',
]

export type FeaturedPromotionMovingBorderProps = {
  borderRadius?: string
  children: React.ReactNode
  className?: string
}

/**
 * Featured promotion wrapper using GlowBorderCard (rotating conic gradient border).
 */
export function FeaturedPromotionMovingBorder({
  borderRadius = FEATURED_PROMOTION_BORDER_RADIUS,
  children,
  className,
}: FeaturedPromotionMovingBorderProps) {
  const prefersReducedMotion = useReducedMotion()

  return (
    <GlowBorderCard
      animationDuration={5}
      blurAmount="20px"
      borderRadius={borderRadius}
      borderWidth="16px"
      className={cn(
        'relative z-30 flex w-full overflow-visible bg-transparent backdrop-blur-none',
        className,
      )}
      contentClassName="flex min-h-0 flex-col items-stretch justify-stretch bg-cream p-0"
      gradientColors={FEATURED_PINK_GLOW_COLORS}
      height="auto"
      inset="-12px"
      outlineWidth="4px"
      paused={prefersReducedMotion ?? false}
      width="100%"
    >
      {children}
    </GlowBorderCard>
  )
}
